export default {
  title: 'Statistik des Immobilienmarktes in der Provinz Antalya',
  tabs: {
    sales: 'Immobilienverkäufe',
    permits: 'Baugenehmigungen'
  }
}
